import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { Button } from '@frontend/design-system';
import { COMPOSER_BREAKPOINTS } from '../../content-composer/constants';
import { useContentComposer } from '../../content-composer/content-composer-provider';

export const AddSectionButton = () => {
  const { setActivePanel } = useContentComposer();

  return (
    <Button
      variant='secondary'
      onClick={() => {
        setActivePanel('toolbox');
      }}
      css={css`
        height: 100%;
        width: fit-content;
        @media (min-width: ${COMPOSER_BREAKPOINTS.MOBILE + 1}px) {
          display: none;
        }
      `}
    >
      <Icon name='plus-small' />
    </Button>
  );
};
